/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
        if ( event.target.classList.contains( 'is-open' ) ) {
          $( 'body' ).addClass( 'overflow-hidden' );
        } else {
          $( 'body' ).removeClass( 'overflow-hidden' );
        }
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( '.open-mobile-child-nav' ).on( 'toggleAfter', ( event ) => {
        const target = event.target.dataset.toggleTarget;
        $( target ).slideToggle();
      } );

      function handleMobileChange( event ) {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        if ( event.matches ) {
          if ( $( '.primary-nav' ).length > 0 ) {
            $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );

            $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
          }
        }
      }

      /* Run the handleMobileChange function when the screen sizes changes based on the mobileSize const */
      const mobileSize = window.matchMedia( '(min-width: 768px)' );
      handleMobileChange( mobileSize );
      mobileSize.addEventListener( 'change', handleMobileChange );

      if ( mobileSize.matches ) {
        $( '.navbar__layer-one .primary-menu-item:first-of-type button' ).trigger( 'click' );
      }

      /* Allow selects to have placeholder styles */
      checkSelectPlaceholder();
      $( '.gfield_select' ).on( 'change', function() {
        checkSelectPlaceholder();
      } );
      function checkSelectPlaceholder() {
        if ( $( '.gfield_select' ).find( 'option:selected' ).hasClass( 'gf_placeholder' ) ) {
          $( '.gfield_select' ).addClass( 'placeholder-selected' );
        } else {
          $( '.gfield_select' ).removeClass( 'placeholder-selected' );
        }
      }

      /* Lazyload all embeds */
      if ( 'IntersectionObserver' in window ) {
        const options = {
          root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
          rootMargin: '0px 0px 100px', // determines how far form the root the intersection callback will trigger
        };
        const embedObserver = new IntersectionObserver( function( entries, observer ) {
          entries.forEach( function( embed ) {
            if ( embed.isIntersecting ) {
              $( embed.target ).attr( 'src', $( embed.target ).attr( 'data-src-defer' ) );
              // remove observer
              embedObserver.unobserve( embed.target );
            }
          } );
        }, options );

        // add the observer to the elements
        $( '[data-src-defer]' ).each( function( index, element ) {
          embedObserver.observe( element );
        } );
      }

      $( '.qty-product-minus' ).on( 'click', function() {
        const productId = $( this ).attr( 'data-product' );
        const currentValue = Number( $( '.ll-product-'+productId ).val() );
        if ( currentValue > 0 ) {
          $( '.ll-product-'+productId ).val( currentValue - 1 );
          const addBtn = $( '.ajax_add_to_cart' );
          addBtn.each( function( elem, elemIndex ) {
            if ( $( this ).data( 'product_id' ) == productId ) {
              $( this ).attr( 'data-quantity', currentValue - 1 );
            }
          } );
        }
      } );

      $( '.qty-cart-minus' ).on( 'click', function( e ) {
        console.log( 'click' );
        e.preventDefault();
        const quantityInput = $( this ).siblings( '.quantity' ).find( '.qty' );
        const currentQuantity = parseInt( quantityInput.val() );
        const newQuantity = currentQuantity - 1;
        if ( newQuantity >= 0 ) {
          quantityInput.val( newQuantity );
        }
      } );

      $( '.qty-cart-add' ).on( 'click', function( e ) {
        e.preventDefault();
        const quantityInput = $( this ).siblings( '.quantity' ).find( '.qty' );
        const currentQuantity = parseInt( quantityInput.val() );
        const newQuantity = currentQuantity + 1;
        if ( newQuantity >= 0 ) {
          quantityInput.val( newQuantity );
        }
      } );

      $( '.qty-product-add' ).on( 'click', function() {
        const productId = $( this ).attr( 'data-product' );
        const currentValue = Number( $( '.ll-product-'+productId ).val() );
        $( '.ll-product-'+productId ).val( currentValue + 1 );
        const addBtn = $( '.ajax_add_to_cart' );
        addBtn.each( function( elem, elemIndex ) {
          if ( $( this ).data( 'product_id' ) == productId ) {
            $( this ).attr( 'data-quantity', currentValue + 1 );
          }
        } );
      } );

      $( '.update_cart' ).on( 'click', function( e ) {
        e.preventDefault();
        const quantityInput = $( this ).siblings( '.quantity' ).find( '.qty' );
        const currentQuantity = parseInt( quantityInput.val() );
        const newQuantity = currentQuantity + 1;
        if ( newQuantity >= 0 ) {
          quantityInput.val( newQuantity );
        }
      } );

      $( '.ll-qty' ).each( function() {
        $( this ).on( 'change', function() {
          const productId = $( this ).attr( 'data-product' );
          const currentValue = Number( $( '.ll-product-'+productId ).val() );
          const addBtn = $( '.ajax_add_to_cart' );
          addBtn.each( function( elem, elemIndex ) {
            if ( $( this ).data( 'product_id' ) == productId ) {
              $( this ).attr( 'data-quantity', currentValue );
            }
          } );
        } );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
